import axios from 'axios';
import store from '@/store';
import { getApiUrl } from '@/common/configs';

const { jwt } = store?.state || window?.localStorage;

class Http {
    constructor() {
        let service = axios.create({});
        service.interceptors.request.use((config) => {
            config.baseURL = getApiUrl();
            config.headers.common['Authorization'] = `${ jwt }`;
            config.headers.common['User-ID'] = store?.getters?.jwtData?.id;
            return config
        });
        service.interceptors.response.use(this.handleSuccess, this.handleError);
        this.service = service;
    }

    redirectTo = (document, path) => {
        document.location = path;
    }

    handleSuccess(response) {
        if (response?.status === 200) {
            return response.data;
        }
        return response;
    }

    handleError = (error) => {
        const path = document?.location?.pathname;
        if (!['/', '/giris'].includes(path) && error.response?.status === 401) {
            // login sayfasi disindaki unauthorized istekleri login'e yonlendir
            this.redirectTo(document, '/giris');
        }
        return Promise.reject(error.response?.data || error.response?.statusText);
    }

    get(path) {
        return this.service.get(path);
    }

    patch(path, payload, callback) {
        return this.service.request({
            method: 'PATCH',
            url: path,
            responseType: 'json',
            data: payload
        }).then((response) => callback(response.status, response.data));
    }

    post(path, payload, config = {}) {
        return this.service.request({
            method: 'POST',
            url: path,
            responseType: 'json',
            data: payload,
            ...config,
        });
    }

    put(path, payload) {
        return this.service.request({
            method: 'PUT',
            url: path,
            responseType: 'json',
            data: payload
        });
    }

    delete(path, payload) {
        return this.service.request({
            method: 'DELETE',
            url: path,
            responseType: 'json',
            data: payload
        });
    }
}

export default new Http;
